import React, { useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { isNonEmptyString, isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";

import FormHistoryView from "components/FormHistoryView";
import { COLUMN_HEADER_KEYS, PRIVILEGES } from "globals/constants";
import { useDictionary, useFormAccesses, useHasPrivileges } from "hooks";
import { getAward } from "store/actions/award";


const AwardHistoryView = () => {
	const { awardId } = useParams();
	const { content: { award } } = useSelector(state => state.award);

	const {
		[PRIVILEGES.AWARD_NOTES_READ]: canReadNotes,
	} = useHasPrivileges([
		PRIVILEGES.AWARD_NOTES_READ,
	]);
	const formAccesses = useFormAccesses(COLUMN_HEADER_KEYS.AWARD, awardId);

	const dictionary = useDictionary("award.history");

	const updateAwardSelection = award => {
		const selections = new Map();
		const awardFeedItem = {
			id: award.id,
			awardId: award.awardId,
			adminTeamMemberData: award.adminTeamMembers,
			adminTeamMembers: isNonEmptyArray(award.adminTeamMembers)
				? award.adminTeamMembers.map(member => member.fullName).join(", ")
				: ""
		};
		selections.set(award.id, awardFeedItem);

		return selections;
	};

	const refreshAward = useCallback(() => {
		getAward(awardId, { isRefresh: true });
	}, [ awardId ]);

	useEffect(() => {
		if (isNonEmptyString(awardId)) {
			getAward(awardId);
		}
	}, [ awardId ]);

	return (
		<FormHistoryView
			instance={award}
			refreshInstance={refreshAward}
			dictionary={dictionary}
			updateInstanceSelection={updateAwardSelection}
			canReadNotes={canReadNotes}
			canAssign={formAccesses.updateAdminTeam}
			adminRole={"SP Award Administrator"}
			formType={COLUMN_HEADER_KEYS.AWARD}
			formIdKey="awardId"
		/>
	);
};

export default AwardHistoryView;
